import createTypes from 'redux-create-action-types';

export const ActionTypes = createTypes('SET_DEFAULT_DOCUMENT_VALIDATION_ATTRIBUTES');
